import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';
import { ICON_ACTION_COLUMN_WIDTH, SUB_COLUMN_WIDTH } from 'utils/constants';
import { Pagination, Typography } from '@mui/material';

const StyledHeaderCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'isSortable',
})<{ isSortable: boolean }>(({ isSortable }) => ({
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    color: 'var(--color-ffffff)',
    cursor: isSortable ? 'pointer' : 'default',
}));

const HeaderContent = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
});

const HeaderTitle = styled(Box)({
    flexGrow: 1,
    marginRight: 10,
});

const FreezeWidgetCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'isFreeze',
})<{ isFreeze?: boolean }>(({ isFreeze }) => ({
    width: 'auto',
    ...(isFreeze && {
        position: 'sticky',
        right: ICON_ACTION_COLUMN_WIDTH + 45,
        backgroundColor: 'var(--color-2281cc)',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 1,
            width: 2,
            height: '100%',
            background: 'linear-gradient(to right, rgba(0, 0, 0, 0.2), transparent)',
        },
    }),
}));

const HeaderIconCell = styled(TableCell)({
    width: ICON_ACTION_COLUMN_WIDTH,
    position: 'sticky',
    right: 0,
    backgroundColor: 'var(--color-2281cc)',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 1,
        width: 2,
        height: '100%',
        background: 'linear-gradient(to right, rgba(0, 0, 0, 0.2), transparent)',
    },
});

const ContentTableCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'isLink',
})<{ isLink?: boolean }>(({ isLink }) => ({
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    fontSize: isLink ? undefined : '16px',
    color: isLink ? 'var(--color-2281cc)' : undefined,
    textDecoration: isLink ? 'underline' : undefined,
    cursor: isLink ? 'pointer' : undefined,
}));

interface ContentSubTableCellProps {
    isFrozen?: boolean;
    isEvenRow?: boolean;
}

const ContentSubTableCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'isFrozen' && prop !== 'isEvenRow',
})<ContentSubTableCellProps>(({ isFrozen, isEvenRow }) => ({
    width: SUB_COLUMN_WIDTH,
    ...(isFrozen
        ? {
              position: 'sticky',
              right: ICON_ACTION_COLUMN_WIDTH + 45,
              backgroundColor: isEvenRow ? 'white' : '#f5f5f5',
              '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 1,
                  width: 2,
                  height: '100%',
                  background: 'linear-gradient(to right, rgba(0, 0, 0, 0.2), transparent)',
              },
          }
        : {}),
}));

const PaginationBox = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontFamily: 'Meiryo',
    gap: '10px',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '20px',
}));

const PaginationText = styled(Typography)(() => ({
    fontFamily: 'Meiryo',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '20px',
}));

const PaginationButtons = styled(Pagination)(() => ({
    mt: 0,
    '& .MuiPaginationItem-root': {
        color: 'black',
        borderColor: 'gray',
    },
    '& .MuiPaginationItem-root.Mui-selected': {
        backgroundColor: 'var(--color-e9e1ff)',
        borderColor: 'var(--color-7949ff)',
        color: 'var(--color-7949ff)',
        fontWeight: 'bold',
    },
}));

export {
    StyledHeaderCell,
    HeaderContent,
    HeaderTitle,
    FreezeWidgetCell,
    HeaderIconCell,
    ContentTableCell,
    ContentSubTableCell,
    PaginationBox,
    PaginationText,
    PaginationButtons,
};
